import type { RootState } from "@/data/store";
import { reattemptWindowEndDatePassed } from "@/features/socratic/socratic-slice/socratic-slice";

import { createDateListener } from "../timeline-listeners/create-date-listener";

/**
 * Listener for the preparation end date in Socratic dialogue.
 *
 * Monitors when the preparation time ends and dispatches the action
 * to automatically start recording if the student hasn't started early.
 */
export const reattemptWindowEndDateListener = createDateListener(
  (state: RootState) => state.socratic.reattemptWindowEndDate,
  (listenerApi) => {
    listenerApi.dispatch(reattemptWindowEndDatePassed());
  }
);
